import { API_BASE } from "@/lib/api";
import { useFileToken, buildPhotoHref } from "@/hooks/useFileToken";

/**
 * Horizontal strip of the tradie's most recent photo dockets.
 * Tapping a thumbnail opens the in-app PhotoViewer in a new tab so the user
 * gets a proper Close + Share action rather than being stranded in Safari's
 * default image viewer. Signed with a file-token so external Safari (PWA
 * escape) can load the image without the app's auth cookie.
 */
export default function RecentDockets({ entries = [] }) {
  const photos = entries.filter((e) => e.photo_path).slice(0, 5);
  const fileToken = useFileToken();
  if (photos.length === 0) return null;
  return (
    <section data-testid="recent-dockets">
      <div className="text-[10px] uppercase tracking-[0.2em] font-heading text-white/40 mb-2">
        Recent receipts
      </div>
      <div className="flex gap-2 overflow-x-auto -mx-4 px-4 pb-1">
        {photos.map((e) => (
          <a
            key={e.id}
            data-testid={`recent-docket-${e.id}`}
            href={buildPhotoHref({
              path: e.photo_path,
              token: fileToken,
              supplier: e.supplier || "",
              name: e.entry_date || "",
            })}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0"
          >
            <img
              src={`${API_BASE}/api/files/${e.photo_path}`}
              alt={e.supplier || "receipt"}
              className="w-16 h-16 rounded-xl object-cover border border-white/10 hover:brightness-110 transition"
            />
          </a>
        ))}
      </div>
    </section>
  );
}
